// removed by extract-text-webpack-plugin
module.exports = {"card":"card__2DEbQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/index.css
// module id = 1365
// module chunks = 0